import Error from "../Components/Error/Error.tsx";

const NotFound = () => {
  return (
    <>
      <Error />
    </>
  );
};

export default NotFound;
